import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "../../../ui";
export const InstructionsTab = () => {
    return (_jsx(Link, { icon: "document", onClick: () => {
            window.open("/static/Руководство_пользователя_сервиса_Анализ_рынка_и_расчет_бизнес_плана.pdf", "new");
        }, children: "\u0418\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0411\u0438\u0437\u043D\u0435\u0441-\u043D\u0430\u0432\u0438\u0433\u0430\u0442\u043E\u0440\u0430 \u041C\u0421\u041F (PDF)" }));
};
